<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VOziDS/tc-custom/9781626814424.jpg?1704761644517" alt="This image is the cover for the book Bad Boy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bad Boy
      </h1>
      <p class="bookDescription body article font2">
        <b>“Guilty pleasures don’t come much tastier” than this sharp romantic comedy from the <i>New York Times</i>–bestselling author of <i>The First Wives Club</i> (<i>People</i>).</b><br/>  <br/> Every Sunday, best friends Tracie and Jonny meet for brunch in Seattle and discuss their love lives. Tracie loves bad boys who seem too good to be true (and usually are)—while Jonny foolishly falls for girls who never like him “that way.”<br/>  <br/> Then Tracie embarks on a makeover to turn him into a bad boy. She teaches him to scope out women at baggage claim; come back from a dinner date with a new girl’s phone number scrawled on his hand; and always carry a motorcycle helmet—even though he doesn’t ride a motorcycle.<br/>  <br/> Jonny quickly becomes a successful heartbreaker . . . just as Tracie realizes that she might be head-over-heels in love with her best friend. But there are some major obstacles in her way—including Jonny’s wondering about why she never liked him for who he was without the leather—in this smart, laugh-out-loud tale of modern romance.<br/>  <br/> “An old-fashioned tale of love and friendship . . . The dialogue is crisp and funny.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Olivia Goldsmith
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b84482ac